/* MOTIV Amsterdam — voegt de "tegel"-glyph toe vóór elk knoplabel.
   Werkt als los DOM-element (niet als ::before/::after) omdat Dawn die twee
   pseudo-elementen al gebruikt voor de knop-rand en -schaduw; hergebruiken
   zou die onzichtbaar maken. Draait ook na cart-drawer/AJAX-updates via een
   MutationObserver. */
(function () {
  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('.button:not([data-motiv-glyph])');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.setAttribute('data-motiv-glyph', 'true');
      var glyph = document.createElement('span');
      glyph.className = 'motiv-btn-glyph';
      glyph.setAttribute('aria-hidden', 'true');
      btn.insertBefore(glyph, btn.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhance();
    });
  } else {
    enhance();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      enhance();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
